const STORAGE_KEY = 'gts-web-theme';

const getSystemTheme = () =>
    typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)')?.matches
        ? 'dark'
        : 'light';

export const getTheme = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        return saved === 'dark' || saved === 'light' ? saved : getSystemTheme();
    } catch {
        return getSystemTheme();
    }
};

export const applyTheme = (theme) => {
    const next = theme === 'dark' ? 'dark' : 'light';
    document.documentElement.dataset.theme = next;
    document.documentElement.style.colorScheme = next;
    return next;
};

export const setTheme = (theme) => {
    const next = applyTheme(theme);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* Storage can be disabled. */ }
    return next;
};

export const initTheme = () => {
    applyTheme(getTheme());
    window.matchMedia?.('(prefers-color-scheme: dark)')
        ?.addEventListener?.('change', () => applyTheme(getTheme()));
};
